import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { isWeather } from "../../function/common";

const DateCell = ({ info, holidays, isHolidayOpen, weather }) => {
  const { isDarkMode } = useSelector((state) => state?.scheduler);
  const current = moment(info.date).format("YYYY-MM-DD");
  const target = holidays
    .filter((h) => {
      const startDate = moment(h.startDt).format("YYYY-MM-DD");
      const endDate = moment(h.endDt).format("YYYY-MM-DD");

      return current >= startDate && current <= endDate;
    })
    .sort((a, b) => (a.gbn === "H" ? -1 : 1));

  const dateFormatted = moment(info.date).format("D");

  // 날씨 가져오기
  const matchWeather = (info) => {
    const date = moment(info).format("YYYY-MM-DD");
    const matchedDate = weather.find((item) => item.date === date);
    if (matchedDate) {
      return isWeather(matchedDate);
    } else {
      return <></>;
    }
  };

  return target.length > 0 ? (
    <>
      <div
        onClick={() => isHolidayOpen(target[0])}
        className="holiday"
        style={{
          color: isDarkMode ? "#efefef" : "#1b1b1b",
        }}>
        {target[0].icon && <img src={`/img/scheduler/${target[0].icon}`} alt={target[0].title} />}
        {target[0].title}
      </div>
      <div className="date" onContextMenu={() => handleContext(current)}>
        <>{matchWeather(info.date)}</>
        <span style={{ color: `#${target[0].color}` }}>{dateFormatted}</span>
      </div>
    </>
  ) : (
    <>
      <div></div>
      <div className="date" onContextMenu={() => handleContext(current)}>
        <>{matchWeather(info.date)}</>
        <span>{dateFormatted}</span>
      </div>
    </>
  );
};

export default DateCell;
